export default __webpack_public_path__ + "static/trey-copeland-logo-0b22b6a0cc7afbf94db8c0ae4d7dcbf2.png";